module.exports = __webpack_public_path__ + "static/media/fiona_peng.12ef524a.png";